import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Group } from "@mantine/core";
import { FormattedMessage } from "react-intl";
import { useCaptureEvent } from "../../components/StyleEditorContext.js";
import { useAppAction, useAppSelector } from "../../hooks/redux.js";
import { getLayersConfigDisplay, setLayersConfigDisplay } from "../../reducers/layersReducer.js";
import { useCallback } from "react";
import { Event } from "../../constants/events.js";
export const LayerConfigControls = ({ layer }) => {
    const captureEvent = useCaptureEvent();
    const currentDisplay = useAppSelector(getLayersConfigDisplay);
    const changeDisplay = useAppAction(setLayersConfigDisplay);
    const handleChangeDisplay = useCallback((display) => {
        captureEvent(Event.ChangeLayersConfigDisplay, {
            display,
        });
        changeDisplay(display);
    }, [changeDisplay, captureEvent]);
    return (_jsxs(Group, { gap: 8, children: [_jsx(Button, { flex: "1 0 0", variant: currentDisplay === "style" ? "filled" : "light", color: currentDisplay === "style" ? "dark" : "gray", c: currentDisplay === "style" ? "white" : "gray", radius: 6, onClick: () => {
                    handleChangeDisplay("style");
                }, children: _jsx(FormattedMessage, { id: "button.style", defaultMessage: "Style" }) }), layer.type !== "background" && (_jsx(Button, { flex: "1 0 0", variant: currentDisplay === "data" ? "filled" : "light", color: currentDisplay === "data" ? "dark" : "gray", c: currentDisplay === "data" ? "white" : "gray", radius: 6, onClick: () => {
                    handleChangeDisplay("data");
                }, children: _jsx(FormattedMessage, { id: "button.data", defaultMessage: "Data" }) })), _jsx(Button, { flex: "1 0 0", variant: currentDisplay === "code" ? "filled" : "light", color: currentDisplay === "code" ? "dark" : "gray", c: currentDisplay === "code" ? "white" : "gray", radius: 6, onClick: () => {
                    handleChangeDisplay("code");
                }, children: _jsx(FormattedMessage, { id: "button.code", defaultMessage: "Code" }) })] }));
};
